module.exports = __webpack_public_path__ + "static/mindy-kaling-08f18cced1f0ec001b517c245e64d33b.jpg";